module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ImportantSeriesView.js"));
	}, "ImportantSeriesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ImportantSeriesView!./src/pages/Shop/Home/ImportantSeries/ImportantSeriesView.js
// module id = 921
// module chunks = 438